'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ElementDragPreviewPositioner = require('./ElementDragPreviewPositioner');

var _ElementDragPreviewPositioner2 = _interopRequireDefault(_ElementDragPreviewPositioner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


var SelectedElementsDragPreviews = function (_React$Component) {
    _inherits(SelectedElementsDragPreviews, _React$Component);

    function SelectedElementsDragPreviews() {
        _classCallCheck(this, SelectedElementsDragPreviews);

        return _possibleConstructorReturn(this, (SelectedElementsDragPreviews.__proto__ || Object.getPrototypeOf(SelectedElementsDragPreviews)).apply(this, arguments));
    }

    _createClass(SelectedElementsDragPreviews, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var item = this.props.item;
            var draggedElements = item.draggedElements;


            return _react2.default.createElement(
                'div',
                { className: 'SelectedElementsDragPreviews' },
                draggedElements.map(function (element, index) {
                    return _react2.default.createElement(_ElementDragPreviewPositioner2.default, _extends({ key: element.get('id'), element: element, index: index
                    }, _this2.props));
                })
            );
        }
    }]);

    return SelectedElementsDragPreviews;
}(_react2.default.Component);

SelectedElementsDragPreviews.propTypes = {
    item: _propTypes2.default.object.isRequired
};

exports.default = SelectedElementsDragPreviews;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/SelectedElementsDragPreviews.js
// module id = 1970
// module chunks = 0